module.exports = __webpack_public_path__ + "6900a86d.jpg";